import React, { memo } from "react";
import InputMask from "react-input-mask";
import { ErrorMsg } from "../error-message";
import { useFormContext } from "react-hook-form";

function DateField({
    invalid = "",
    icon,
    placeholder,
    name
}) {
    const { register, formState: { errors } } = useFormContext()

    return <div>
        <div className={`text-field text-field--fluid ${invalid ? "text-field--invalid" : ""}`}>
            {icon && icon}
            <InputMask
                mask="99/99/9999"
                placeholder={placeholder}
                id={name}
                {...register(name)} />

        </div>
        <ErrorMsg errors={errors} name={name} />
    </div>
}
export default memo(DateField);
